import { FC } from 'react';

import { UiCleanInput } from 'src/components/UI/inputs/CleanInput';
import { UiCleanRadioGroup } from 'src/components/UI/radioGroup/CleanRadioGroup';
import { Enums } from 'src/models/enums';
import { OrganizationOldVerifyPageModelType } from 'src/models/Organization/OldVerify';
import { OrganizationOldVerifyFormValues } from 'src/pages/Organization/OldVerify/component';
import { OrganizationOldVerifyFilesPartial } from 'src/pages/Organization/OldVerify/partials/Files';
import { useNsTHelper } from 'src/utils/i18n';
import { StateFormReturnType } from 'src/utils/stateForm';
import { useStateFormValueWatch } from 'src/utils/stateForm/useFormWatch/useStateFormValueWatch';

type Props = {
  model: OrganizationOldVerifyPageModelType;
  locale: string;
  formProps: StateFormReturnType<OrganizationOldVerifyFormValues>;
  resetDirtyForm: () => void;
};

export const OrganizationOldVerifyNotVerificationCardPartial: FC<Props> = ({
  model,
  locale,
  formProps,
  resetDirtyForm,
}) => {
  const tHelper = useNsTHelper(locale, 'notVerificationCard');

  const Approved = model.StatusID === Enums.organizations.StatusCode.Approved;
  const CanDelete = !Approved;
  const CanUpload = !Approved;

  const files = useStateFormValueWatch<OrganizationOldVerifyFormValues, 'Files'>(formProps.getSubscribeProps, 'Files');

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="card hoverable text-center">
          <div className="card-content alwaysEnabled">
            <div className="row">
              <div className="col-sm-12">
                <p className="text-center">{tHelper('chooseVerificationMethod')}</p>
                <UiCleanRadioGroup
                  formProps={formProps}
                  name="ProofOfAffiliationType"
                  options={[
                    {
                      value: Enums.organizations.ProofOfAffiliationTypeCode.Website,
                      label: tHelper('verificationMethods.website'),
                      innerComponent: (
                        <div className="col-sm-9">
                          <UiCleanInput
                            formProps={formProps}
                            name="ProofOfAffiliationWebsite"
                            placeholder="www.organizationname.com/about"
                            maxLength={255}
                            disabled={Approved}
                          />
                        </div>
                      ),
                    },
                    {
                      value: Enums.organizations.ProofOfAffiliationTypeCode.Other,
                      label: tHelper('verificationMethods.another'),
                      innerComponent: (
                        <OrganizationOldVerifyFilesPartial
                          title={tHelper('filesTitle')}
                          files={files}
                          canDelete={CanDelete}
                          locale={locale}
                          canUpload={CanUpload}
                          fileNamePrefix={`VerifyAccount/${model.OrganizationID}/`}
                          onFileDeleted={(fileInfo) => {
                            formProps.setValue(
                              'Files',
                              files.filter(({ Uri }) => Uri !== fileInfo.Uri)
                            );

                            resetDirtyForm();
                          }}
                          onFileAdded={(data) => {
                            const files = formProps.getValue('Files');

                            files.push({
                              ID: 0, // a temporary file
                              Uri: data.fullPath,
                              Name: data.fileName,
                            });

                            formProps.setValue('Files', files);
                          }}
                        />
                      ),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
